var React = require('react');

function EsES (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"15","fill":"#c60b1e","key":0}),React.createElement("rect",{"width":"20","height":"5.5","fill":"#ffc400","y":"4.8","key":1})]);
}

EsES.defaultProps = {"height":"15px","width":"20px","preserveAspectRatio":"xMinYMin slice","overflow":"visible"};

module.exports = EsES;

EsES.default = EsES;
